export default {
    common: {
        done: "Fatto",
        duplicate: "Duplica",
        loading: "Caricamento...",
        loadingProducts: "Caricamento prodotti...",
        loadingPostalCodes: "Caricamento codici postali...",
        loadingRestaurantData: "Caricamento dati ristoranti...",
        all: "Tutti",
        save: "Salva",
        saving: "Salvataggio...",
        cancel: "Annulla",
        delete: "Elimina",
        deleting: "Eliminazione...",
        edit: "Modifica",
        add: "Aggiungi",
        search: "Cerca",
        filter: "Filtra",
        reset: "Reimposta",
        confirm: "Conferma",
        close: "Chiudi",
        refresh: "Aggiorna",
        back: "Indietro",
        next: "Successivo",
        previous: "Precedente",
        first: "Prima",
        last: "Ultima",
        submit: "Invia",
        yes: "Sì",
        no: "No",
        actions: "Azioni",
        status: "Stato",
        date: "Data",
        time: "Ora",
        minutes: "minuti",
        name: "Nome",
        description: "Descrizione",
        price: "Prezzo",
        quantity: "Quantità",
        total: "Totale",
        language: "Lingua",
        customer: "Cliente",
        company: "Azienda",
        view: "Vedi",
        page: "Pagina",
        update: "Aggiorna",
        paymentStatus: "Stato pagamento",
        more: "Più",
        seeLess: "Vedi meno",
        create: "Creare",
        title: "Titolo",
        message: "Messaggio",
    },
    header: {
        profile: "Il mio account",
        myRestaurant: "Il mio ristorante",
        changePassword: "Modifica password",
        logout: "Disconnetti",
        administrator: "Amministratore",
        restaurant: "Ristorante",
    },
    roles: {
        administrator: "AMMINISTRATORE",
        user: "UTENTE",
        franchise: "FRANCHISING",
        restaurant: "RISTORANTE",
        technicalSupport: "SUPPORTO TECNICO",
        guest: "CLIENTE",
    },
    sidebar: {
        dashboard: "Dashboard",
        pos: "POS",
        posSystem: "Sistema POS",
        sales: "Vendite",
        orders: "Ordini",
        transactions: "Transazioni",
        salesReport: "Rapporto vendite",
        management: "Gestione",
        timeSlots: "Fasce orarie",
        deliveryZones: "Zone di consegna",
        products: "Prodotti",
        categories: "Categorie",
        ingredients: "Ingredienti",
        ingredientTypes: "Tipi di ingredienti",
        managmentCategories: "Gestione delle categorie di ingredienti",
        features: "Features",
        supplements: "Supplementi",
        supplementTypes: "Tipi di supplementi",
        ingredientBases: "Ingredienti di base",
        campaigns: "Campagne",
        emailCampaigns: "Campagne e-mail",
        pushNotifications: "Notifiche push",
        programs: "Referral & Fedeltà",
        customers: "Clienti",
        users: "Utenti",
        userList: "Lista utenti",
        restaurants: "Ristoranti",
        restaurantList: "Lista ristoranti",
        franchises: "Franchise",
        accounts: "Account",
        coupon: "Coupon",
        openingHours: "Orari di apertura",
        paymentMethods: "Metodi di pagamento",
        logout: "Disconnetti",
        referral: "Programmi",
        loyalty: "Fedeltà & Parrainage",
        giftCards: "Carte Regalo",
    },
    order: {
        orders: "Ordini",
        removed: "Rimosso(i)",
        noOrders: "Nessun ordine trovato.",
        orderDetails: "Dettagli ordine",
        createDate: "Creato il:",
        pickupDate: "Data di ritiro:",
        paymentMethod: "Metodo di pagamento:",
        orderType: "Tipo di ordine:",
        notSpecified: "Non specificato",
        immediately: "IMMEDIATAMENTE",
        customer: "Cliente",
        customerInfo: "Informazioni Cliente",
        deliveryAddress: "Indirizzo di consegna",
        orderItems: "Articoli dell'ordine",
        productList: "Lista prodotti",
        subtotal: "Subtotale",
        deliveryFee: "Costi di consegna",
        discount: "Sconto",
        tax: "Tassa",
        grandTotal: "Totale generale",
        orderStatus: "Stato dell'ordine",
        notes: "Note",
        invoice: "Fattura & Referral",
        invoiceNumber: "Fattura:",
        coupon: "Coupon:",
        civility: "Titolo:",
        customerType: "Tipo cliente:",
        company: "Azienda",
        classic: "Classico",
        fullName: "Nome e Cognome:",
        email: "E-mail:",
        phoneNumber: "Numero di telefono",
        quantity: "Quantità",
        total: "Totale",
        ingredients: "Ingredienti",
        supplements: "Supplementi",
        noSupplements: "Nessun supplemento",
        supplementName: "NOME SUPPLEMENTO",
        ingredientName: "NOME INGREDIENTE",
        type: "TIPO",
        price: "PREZZO",
        description: "DESCRIZIONE",
        orderNote: "Nota ordine",
        orderId: "ID Ordine-",
        estimatedDeliveryTime: "Tempo di consegna stimato",
        customerInstruction: "Istruzione cliente",
        orderSummary: "Riepilogo ordine",
        includingVat: "IVA INCLUSA (2,60%)",
        includingVatDynamic: "IVA INCLUSA ({rate}%)",
        additionalFees: "COSTI AGGIUNTIVI",
        noIngredients: "Nessun Ingrediente",
        unknownProduct: "Prodotto sconosciuto",
        noCategory: "Nessuna categoria",
        yes: "Sì",
        no: "No",
        free: "Gratuito",
        paid: "A pagamento",
        shouldSlice: "Dobbiamo tagliare",
        paymentAddress: "Indirizzo di fatturazione",
        street: "Via",
        number: "N.",
        postalCode: "CAP",
        locality: "Località",
        phone: "Telefono",
        totalGross: "TOTALE LORDO",
        vat: "2,60% IVA",
        productName: "NOME PRODOTTO",
        productPrice: "PREZZO PRODOTTO",
        paymentStatus: "Stato pagamento",
        paymentMethodTitle: "Metodo di pagamento",
        paymentMethods: {
            payClickCollectCash: "Pagamento in contanti",
            payClickCollectCarte: "Pagamento con carta",
            payDeliveryCash: "Pagamento in contanti alla consegna",
            payDeliveryCarte: "Pagamento con carta alla consegna",
            online: "Pagamento online (Walle)",
        },
        orderTypes: {
            delivery: "Consegna",
            clickCollect: "Da asporto",
            dineIn: "Sul posto",
        },
        status: {
            pending: "In attesa",
            processing: "In elaborazione",
            readyForDelivery: "Pronto per la consegna",
            outForDelivery: "In consegna",
            delivered: "Consegnato",
            cancelled: "Annullato",
        },
        preOrder: "PRE-ORDINE",
        rightAway: "SUBITO",
        products: "prodotti",
        netTotal: "Totale netto",
        viewDetails: "Vedi dettagli",
        viewPdf: "Visualizza PDF",
        noOrdersAvailable: "Nessun ordine disponibile.",
        unknown: "Sconosciuto",
        transactionReference: "Riferimento transazione",
        pdf: "PDF",
    },
    product: {
        addProduct: "Aggiungi prodotto",
        editProduct: "Modifica prodotto",
        productName: "Nome prodotto",
        productDescription: "Descrizione prodotto",
        productPrice: "Prezzo prodotto",
        productCategory: "Categoria prodotto",
        productImage: "Immagine prodotto",
        nutritionalValues: "Note e valori nutrizionali",
        multilingualTranslations: "Traduzioni multilingue",
        complete: "Completo",
        incomplete: "Incompleto",
        giveNote: "Fornisci una nota e valore nutrizionale",
        type: "Tipo",
        category: "Categoria",
        restaurant: "Ristorante",
        positioning: "Posizionamento",
        image: "Immagine",
        uploadFile: "Carica file",
        httpsLink: "Link HTTPS",
        acceptedFormats: "Formati accettati: JPEG, PNG, WebP (max 2 MB)",
        enterValidHttpsUrl: "Inserisci un URL HTTPS valido verso un'immagine",
        productVariation: "Variazione del prodotto (Specificare le diverse taglie)",
        updateVariation: "Aggiorna variazione",
        addVariation: "Aggiungi una variazione",
        sizes: "taglia/e",
        noSize: "Nessuna taglia",
        specifyProductSizes: "Specificare le diverse taglie del prodotto",
        size: "Taglia",
        takeawayPrice: "Prezzo da asporto",
        deliveryPriceLabel: "Prezzo di consegna",
        specificSizeDescription: "Descrizione specifica per questa taglia",
        add: "Aggiungi",
        validate: "Conferma",
        remove: "Rimuovi",
        noSizeAdded: "Nessuna taglia aggiunta per il momento",
        SIZE: "TAGLIA",
        TAKEAWAY_PRICE: "PREZZO DA ASPORTO",
        DELIVERY_PRICE: "PREZZO DI CONSEGNA",
        DESCRIPTION: "DESCRIZIONE",
        ACTIONS: "AZIONI",
        addTurkeyBreast: "Aggiungi petto di tacchino",
        addHam: "Aggiungi Prosciutto",
        addPowderedSugar: "Aggiungi zucchero a velo",
        addSauces: "Aggiungi salse",
        addCheese: "Aggiungi formaggio",
        removeAllOptions: "Rimuovi tutte le opzioni",
        chooseAppropriateRestaurant: "Scegli il ristorante appropriato",
        restaurantNotMatchCategory: "Il ristorante selezionato non corrisponde alla categoria del prodotto. Si prega di scegliere il ristorante appropriato.",
        baseIngredients: "Ingredienti di base",
        updateIngredients: "Aggiorna ingredienti",
        addBaseIngredients: "Aggiungi ingredienti di base",
        noIngredientSelected: "Nessun ingrediente selezionato",
        searchBaseIngredient: "Cerca un ingrediente di base",
        selectedIngredients: "Ingredienti selezionati",
        noIngredientFound: "Nessun ingrediente trovato per",
        selectPizzaBaseIngredients: "Seleziona gli ingredienti di base della pizza",
        baseSupplements: "Supplementi di base",
        updateSupplements: "Aggiorna supplementi",
        addBaseSupplements: "Aggiungi supplementi di base",
        noSupplementSelected: "Nessun supplemento selezionato",
        searchSupplement: "Cerca un supplemento",
        selectedSupplements: "Supplementi selezionati",
        noSupplementFound: "Nessun supplemento trovato per",
        selectBaseSupplements: "Seleziona i supplementi di base",
        productNameInLanguage: "Nome prodotto in",
        descriptionInLanguage: "Descrizione in",
        notesInLanguage: "Note in",
        update: "Aggiorna",
        categoryResetWarning: "La categoria è stata reimpostata perché non corrisponde al ristorante selezionato.",
        invalidUrlMessage: "URL non valido. Si prega di inserire un URL valido (es. https://esempio.com/immagine.jpg)",
        categoryNotBelongRestaurant: "Questa categoria non appartiene al ristorante selezionato. Si prega di scegliere una categoria appropriata.",
    },
    category: {
        addCategory: "Aggiungi categoria",
        editCategory: "Modifica categoria",
        categoryName: "Nome categoria",
        categoryDescription: "Descrizione categoria",
        categoryImage: "Immagine categoria",
        multilingualTranslations: "Traduzioni multilingue",
        complete: "Completo",
        incomplete: "Incompleto",
    },
    ingredient: {
        addIngredient: "Aggiungi ingrediente",
        editIngredient: "Modifica ingrediente",
        ingredientName: "Nome ingrediente",
        ingredientDescription: "Descrizione ingrediente",
        ingredientPrice: "Prezzo ingrediente",
        ingredientImage: "Immagine ingrediente",
        ingredientPosition: "Posizione",
        ingredientPositionPlaceholder: "es. 1, 2, 3...",
        ingredientPositionHelp: "Posizione dell'ingrediente nella lista (opzionale)",
        multilingualTranslations: "Traduzioni multilingue",
        complete: "Completo",
        incomplete: "Incompleto",
        manageTypes: "Gestisci tipi",
        manageTypePositions: "Gestisci posizioni dei tipi di ingredienti",
        noTypesAvailable: "Nessun tipo di ingrediente disponibile",
        noIngredientTypesAvailable: "Nessun tipo di ingrediente disponibile",
        addIngredientType: "Aggiungi tipo di ingrediente",
        editIngredientType: "Modifica tipo di ingrediente",
        code: "Codice",
        label: "Etichetta",
        typeCreated: "Tipo di ingrediente creato con successo",
        typeUpdated: "Tipo di ingrediente aggiornato con successo",
        typeDeleted: "Tipo di ingrediente eliminato con successo",
        errorLoadingTypes: "Errore nel caricamento dei tipi di ingredienti",
        errorSavingType: "Errore nel salvataggio del tipo di ingrediente",
        errorDeletingType: "Errore nell'eliminazione del tipo di ingrediente",
        errorUpdatingPosition: "Errore nell'aggiornamento della posizione",
        deleteTypeConfirmation: "Conferma eliminazione",
        deleteTypeConfirmationText: "Sei sicuro di voler eliminare questo tipo di ingrediente?<br />Questa azione è irreversibile. Gli ingredienti associati a questo tipo avranno il loro tipo impostato su NULL.",
        codeHelp: "Il codice deve essere univoco (es: PESCE, FORMAGGIO, ecc.)",
        positionHelp: "Posizione di visualizzazione (opzionale, minimo 1)",
        translations: "Traduzioni",
        notDefined: "Non definito",
        manageTranslations: "Gestisci traduzioni",
        translationUpdated: "Traduzione aggiornata con successo",
        errorUpdatingTranslation: "Errore nell'aggiornamento della traduzione",
        noIngredients: "Nessun ingrediente al momento",
        type: "Tipo",
        position: "Posizione",
        deleteConfirmation: "Conferma eliminazione",
        deleteConfirmationText: "Sei sicuro di voler eliminare questo ingrediente?<br />Questa azione è irreversibile.",
        invalidPosition: "Inserisci una posizione valida (minimo 1)",
        positionUpdated: "Posizione aggiornata con successo",
        paginationInfo: "Visualizzazione da {start} a {end} di {total} risultati",
        namePlaceholder: "es. Pepe",
        managePositions: "Gestisci posizioni",
        selectType: "Seleziona un tipo",
        typePlaceholder: "Tipo di ingrediente in {lang}",
        namePlaceholderLang: "Nome ingrediente in {lang}",
        icon: "Icona",
        imageUrlPlaceholder: "Incolla l'URL dell'immagine (es. https://...)",
        variationLabel: "Variazione ingrediente (Specifica le diverse dimensioni)",
        updateVariation: "Aggiorna variazione",
        addVariation: "Aggiungi una variazione",
        size: "Dimensione",
        noSizeAdded: "Nessuna dimensione aggiunta al momento",
        noSizeAddedModal: "Nessuna dimensione aggiunta al momento",
        specifySizes: "Specifica le diverse dimensioni dell'ingrediente",
        sizePlaceholder: "Grande",
        pricePlaceholder: "12.90",
        remove: "Rimuovi",
        addVariationRequired: "Aggiungi almeno una variazione (dimensione/prezzo) per l'ingrediente",
    },
    supplement: {
        addSupplement: "Aggiungi supplemento",
        editSupplement: "Modifica supplemento",
        supplementName: "Nome del supplemento",
        supplementDescription: "Descrizione del supplemento",
        supplementPrice: "Prezzo del supplemento",
        supplementImage: "Immagine del supplemento",
        supplementPosition: "Posizione",
        supplementPositionPlaceholder: "es. 1, 2, 3...",
        supplementPositionHelp: "Posizione del supplemento nell'elenco (opzionale)",
        multilingualTranslations: "Traduzioni multilingue",
        complete: "Completo",
        incomplete: "Incompleto",
        manageTypes: "Gestisci tipi",
        manageTypePositions: "Gestisci posizioni dei tipi di supplemento",
        noTypesAvailable: "Nessun tipo di supplemento disponibile",
        noSupplementTypesAvailable: "Nessun tipo di supplemento disponibile",
        addSupplementType: "Aggiungi tipo di supplemento",
        editSupplementType: "Modifica tipo di supplemento",
        code: "Codice",
        label: "Etichetta",
        typeCreated: "Tipo di supplemento creato con successo",
        typeUpdated: "Tipo di supplemento aggiornato con successo",
        typeDeleted: "Tipo di supplemento eliminato con successo",
        errorLoadingTypes: "Errore nel caricamento dei tipi di supplemento",
        errorSavingType: "Errore nel salvataggio del tipo di supplemento",
        errorDeletingType: "Errore nell'eliminazione del tipo di supplemento",
        errorUpdatingPosition: "Errore nell'aggiornamento della posizione",
        deleteTypeConfirmation: "Conferma eliminazione",
        deleteTypeConfirmationText: "Sei sicuro di voler eliminare questo tipo di supplemento?<br />Questa azione è irreversibile. I supplementi associati a questo tipo avranno il loro tipo impostato su NULL.",
        codeHelp: "Il codice deve essere unico (es. SALSA, FORMAGGIO, ecc.)",
        positionHelp: "Posizione di visualizzazione (opzionale, minimo 1)",
        translations: "Traduzioni",
        notDefined: "Non definito",
        manageTranslations: "Gestisci traduzioni",
        translationUpdated: "Traduzione aggiornata con successo",
        errorUpdatingTranslation: "Errore nell'aggiornamento della traduzione",
        noSupplements: "Nessun supplemento al momento",
        type: "Tipo",
        position: "Posizione",
        deleteConfirmation: "Conferma eliminazione",
        deleteConfirmationText: "Sei sicuro di voler eliminare questo supplemento?<br />Questa azione è irreversibile.",
        invalidPosition: "Inserisci una posizione valida (minimo 1)",
        positionUpdated: "Posizione aggiornata con successo",
        paginationInfo: "Visualizzazione da {start} a {end} di {total} risultati",
        namePlaceholder: "es. Salsa piccante",
        managePositions: "Gestisci posizioni",
        selectType: "Seleziona un tipo",
        typePlaceholder: "Tipo di supplemento in {lang}",
        namePlaceholderLang: "Nome del supplemento in {lang}",
        icon: "Icona",
        imageUrlPlaceholder: "URL dell'immagine del supplemento",
        variationLabel: "Variazioni di prezzo",
        updateVariation: "Aggiorna variazioni",
        addVariation: "Aggiungi variazioni",
        size: "Dimensione",
        noSizeAdded: "Nessuna dimensione aggiunta al momento",
        noSizeAddedModal: "Nessuna dimensione aggiunta al momento",
        specifySizes: "Specifica le diverse dimensioni del supplemento",
        sizePlaceholder: "Grande",
        pricePlaceholder: "2.50",
        remove: "Rimuovi",
        addVariationRequired: "Aggiungi almeno una variazione (dimensione/prezzo) per il supplemento",
    },
    feature: {
        addFeature: "Aggiungi Feature",
        editFeature: "Modifica Feature",
        featureName: "Nome Feature",
        featureDescription: "Descrizione Feature",
        featurePrice: "Prezzo Feature",
        featureImage: "Immagine Feature",
        featurePosition: "Posizione",
        featurePositionPlaceholder: "es. 1, 2, 3...",
        featurePositionHelp: "Posizione della feature nella lista (opzionale)",
        multilingualTranslations: "Traduzioni multilingue",
        complete: "Completo",
        incomplete: "Incompleto",
        translations: "Traduzioni",
        notDefined: "Non definito",
        manageTranslations: "Gestisci traduzioni",
        translationUpdated: "Traduzione aggiornata con successo",
        errorUpdatingTranslation: "Errore nell'aggiornamento della traduzione",
        noFeatures: "Nessuna feature al momento",
        position: "Posizione",
        deleteConfirmation: "Conferma eliminazione",
        deleteConfirmationText: "Sei sicuro di voler eliminare questa feature?<br />Questa azione è irreversibile.",
        invalidPosition: "Inserisci una posizione valida (minimo 1)",
        positionUpdated: "Posizione aggiornata con successo",
        paginationInfo: "Visualizzazione da {start} a {end} di {total} risultati",
        namePlaceholder: "es. Nuova Feature",
        managePositions: "Gestisci posizioni",
        namePlaceholderLang: "Nome feature in {lang}",
        icon: "Icona",
        imageUrlPlaceholder: "URL immagine feature",
        variationLabel: "Variazioni di prezzo",
        updateVariation: "Aggiorna variazioni",
        addVariation: "Aggiungi variazioni",
        size: "Dimensione",
        noSizeAdded: "Nessuna dimensione aggiunta al momento",
        noSizeAddedModal: "Nessuna dimensione aggiunta al momento",
        specifySizes: "Specifica le diverse dimensioni della feature",
        sizePlaceholder: "Grande",
        pricePlaceholder: "2.50",
        remove: "Rimuovi",
        addVariationRequired: "Aggiungi almeno una variazione (dimensione/prezzo) per la feature",
        features: "caratteristiche"
    },
    auth: {
        login: "Accedi",
        loginButton: "Accedi",
        register: "Registrati",
        registerButton: "Iscriviti",
        createAccount: "Crea il tuo account",
        forgotPassword: "Password dimenticata?",
        forgotPasswordText: "Inserisci il tuo indirizzo e-mail qui sotto e ti invieremo la password recuperata",
        resetPassword: "Reimposta password",
        email: "E-mail",
        emailAddress: "Indirizzo e-mail",
        password: "Password",
        confirmPassword: "Conferma password",
        firstName: "Nome",
        lastName: "Cognome",
        name: "Nome",
        rememberMe: "Ricorda",
        backToSignIn: "Torna al login",
        alreadyHaveAccount: "Hai già un account?",
        dontHaveAccount: "Non hai un account?",
        logInNow: "Accedi ora",
        registerNow: "Registrati ora",
        acceptTerms: "Accetto tutti i",
        termsAndConditions: "Termini e condizioni",
        submit: "Invia",
        invalidCredentials: "Nome utente o password non validi",
        missingToken: "Token di autenticazione mancante",
    },
    validation: {
        required: "Questo campo è obbligatorio",
        email: "Inserisci un'e-mail valida",
        minLength: "Questo campo deve contenere almeno {min} caratteri",
        maxLength: "Questo campo non può superare {max} caratteri",
        passwordMismatch: "Le password non corrispondono",
    },
    messages: {
        success: {
            saved: "Salvato con successo",
            deleted: "Eliminato con successo",
            updated: "Aggiornato con successo",
            paymentMethodUpdated: "Metodo di pagamento aggiornato con successo",
            paymentMethodActivated: "Metodo di pagamento attivato con successo",
            paymentMethodDeactivated: "Metodo di pagamento disattivato con successo",
            paymentMethodAdded: "Metodo di pagamento aggiunto con successo",
            userDeleted: "Utente eliminato con successo",
            userStatusUpdated: "Stato utente aggiornato con successo",
            postalCodeAdded: "Codice postale aggiunto con successo",
            postalCodeRemoved: "Codice postale {code} rimosso",
            variationsUpdated: "Variazioni aggiornate con successo",
            imageSelected: "Immagine selezionata con successo",
            openingHoursDeleted: "Orari di apertura eliminati con successo",
            userAddedToCampaign: "Utente aggiunto alla campagna",
            couponRemoved: "Coupon rimosso",
            newOrderReceived: "Nuovo ordine ricevuto!",
            newOrderInRestaurant: "Nuovo ordine in un ristorante",
            ingredientAdded: "Ingrediente aggiunto con successo",
            ingredientRemoved: "Ingrediente rimosso con successo",
            baseIngredientsValidated: "Ingredienti base validati",
            supplementAdded: "Supplemento aggiunto con successo",
            supplementRemoved: "Supplemento rimosso con successo",
            baseSupplementsValidated: "Supplementi base validati",
            printTicketSuccess: "🎉 Biglietto stampato con successo",
            timeSlotDeleted: "Fascia oraria eliminata con successo",
            timeSlotActivated: "Fascia oraria attivata con successo",
            timeSlotDeactivated: "Fascia oraria disattivata con successo",
        },
        error: {
            generic: "Si è verificato un errore",
            loadFailed: "Errore durante il caricamento",
            network: "Errore di connessione",
            unauthorized: "Non autorizzato",
            notFound: "Risorsa non trovata",
            invalidPaymentMethod: "Metodo di pagamento non valido",
            paymentMethodUpdateFailed: "Errore durante l'aggiornamento del metodo di pagamento",
            loadPaymentMethodsFailed: "Errore durante il caricamento dei metodi di pagamento",
            updateFailed: "Errore durante l'aggiornamento",
            statusUpdateFailed: "Errore durante l'aggiornamento dello stato",
            paymentStatusUpdateFailed: "Errore durante l'aggiornamento dello stato di pagamento",
            deleteUserFailed: "Errore durante l'eliminazione dell'utente",
            updateUserStatusFailed: "Errore durante l'aggiornamento dello stato utente",
            loadUsersFailed: "Errore durante il caricamento degli utenti",
            restaurantIdNotFound: "ID ristorante non trovato",
            loadDeliveryZoneFailed: "Errore durante il caricamento della zona di consegna",
            loadCategoriesFailed: "Errore durante il caricamento delle categorie",
            loadRestaurantsFailed: "Errore durante il caricamento dei ristoranti",
            loadOrdersFailed: "Errore durante il caricamento degli ordini",
            loadCampaignsFailed: "Errore durante il caricamento delle campagne",
            loadProductsFailed: "Errore durante il caricamento dei prodotti",
            loadIngredientsFailed: "Errore durante il caricamento degli ingredienti",
            loadSupplementsFailed: "Errore durante il caricamento dei supplementi",
            loadIngredientBasesFailed: "Errore durante il caricamento degli ingredienti base",
            loadOpeningHoursFailed: "Errore durante il caricamento degli orari di apertura",
            loadDeliveryZonesFailed: "Errore durante il caricamento delle zone di consegna",
            loadTimeSlotsFailed: "Errore durante il caricamento delle fasce orarie",
            loadCouponsFailed: "Errore durante il caricamento dei coupon",
            loadFranchisesFailed: "Errore durante il caricamento delle franchise",
            loadOperationsFailed: "Errore durante il caricamento delle operazioni",
            loadDataFailed: "Errore durante il caricamento dei dati",
            loadPostalCodesFailed: "Errore durante il caricamento dei codici postali",
            loadOrderTypesFailed: "Errore durante il caricamento dei tipi di ordine",
            loadCustomerInfoFailed: "Errore durante il caricamento delle informazioni cliente",
            loadTimeSlotFailed: "Errore nel caricamento della fascia oraria",
            saveFeatureFailed: "Errore nel salvataggio della feature",
            loadFeatureFailed: "Errore nel caricamento della feature",
            deleteFeatureFailed: "Errore nell'eliminazione della feature",
            updateFeaturePositionFailed: "Errore nell'aggiornamento della posizione della feature",
            fileTypeNotAllowed: "Tipo di file non consentito",
            fileTooLarge: "File troppo grande",
            invalidQuantity: "Quantità non valida",
            restaurantInfoMissing: "Informazioni ristorante mancanti",
            fillAllFields: "Si prega di compilare tutti i campi",
            couponAlreadyApplied: "Un coupon è già stato applicato",
            enterPromoCode: "Si prega di inserire un codice promozionale",
            invalidPromoCode: "Codice promozionale non valido",
            imageUploadFailed: "Errore durante il caricamento dell'immagine",
            selectValidImageFile: "Si prega di selezionare un file immagine valido",
            fileSizeExceeded: "La dimensione del file non deve superare 5 MB",
            deletionFailed: "Errore durante l'eliminazione",
            invalidPrice: "Il prezzo deve essere un numero valido",
            ingredientBaseNameRequired: "Il nome dell'ingrediente base è obbligatorio",
            deleteTimeSlotFailed: "Errore durante l'eliminazione della fascia oraria",
            deleteOrderFailed: "Errore durante l'eliminazione dell'ordine",
            deleteVariationFailed: "Errore durante l'eliminazione della variazione",
            deleteProductFailed: "Errore durante l'eliminazione del prodotto",
            deletePostalCodeFailed: "Errore durante l'eliminazione del codice postale",
            deleteZoneFailed: "Errore durante l'eliminazione della zona",
            updateStatusFailed: "Errore durante l'aggiornamento dello stato",
            updateZoneFailed: "Errore durante l'aggiornamento della zona",
            updateStelaStatusFailed: "Errore durante l'aggiornamento dello stato stela",
            updateFeaturedStatusFailed: "Errore durante l'aggiornamento dello stato featured",
            selectRestaurant: "Si prega di selezionare un ristorante",
            saveTimeSlotFailed: "Errore durante il salvataggio della fascia oraria",
            saveOpeningHoursFailed: "Errore durante il salvataggio degli orari di apertura",
            generatePdfFailed: "Errore durante la generazione del PDF",
            printTicketFailed: "Errore durante la stampa del biglietto",
            loadExistingIngredientsFailed: "Errore durante il caricamento degli ingredienti esistenti",
            fillRequiredFields: "Si prega di compilare tutti i campi obbligatori",
            restaurantNotSelected: "Ristorante non selezionato",
            provideImageOrUrl: "Si prega di fornire un'immagine (file o URL)",
            urlMustStartWithHttps: "L'URL deve iniziare con https://",
            ingredientAlreadyAdded: "Questo ingrediente è già stato aggiunto",
            supplementAlreadyAdded: "Questo supplemento è già stato aggiunto",
            loadExistingSupplementsFailed: "Errore durante il caricamento dei supplementi esistenti",
            invalidProductId: "ID prodotto non valido",
            missingCategoryId: "ID categoria mancante",
            editFeatureToImplement: "Funzionalità di modifica da implementare",
            loadUserAddressesFailed: "Errore durante il caricamento degli indirizzi utente",
            loadRestaurantInfoFailed: "Errore durante il caricamento delle informazioni del ristorante",
            loadRestaurantDetailsFailed: "Errore durante il caricamento dei dettagli del ristorante",
            reloadDataFailed: "Errore durante il ricaricamento dei dati",
            loadProductFailed: "Errore durante il caricamento del prodotto",
        },
        warning: {
            userAlreadyInList: "Questo utente è già nella lista",
            selectUser: "Si prega di selezionare un utente",
            couponAlreadyApplied: "Un coupon è già stato applicato",
        },
    },
    lists: {
        add: "Aggiungi",
        search: "Cerca",
        searchProduct: "Cerca un prodotto",
        searchOrder: "Cerca un ordine",
        filterByCategory: "Filtra per categoria",
        selectRestaurant: "Seleziona un ristorante",
        restaurant: "Ristorante",
        id: "ID",
        name: "NOME",
        category: "CATEGORIA",
        status: "STATO",
        notificationStatus: {
            draft: "Bozza",
            sent: "Inviato",
        },
        createdAt: "CREATO IL",
        featured: "IN EVIDENZA",
        size: "DIMENSIONE",
        ref: "RIF",
        type: "TIPO",
        client: "CLIENTE",
        amount: "IMPORTO",
        orderStatus: "STATO ORDINE",
        paymentStatus: "STATO PAGAMENTO",
        phoneNumber: "NUMERO DI TELEFONO",
        actions: "AZIONI",
        cancel: "Annulla",
        delete: "Elimina",
        confirmDelete: "Sei sicuro di voler eliminare questo prodotto?",
        confirmDeleteText: "Questa azione è irreversibile.",
        takeaway: "Da asporto",
        dineIn: "Sul posto",
        delivery: "Consegna",
        pending: "In attesa",
        confirmed: "Confermato",
        preparing: "In preparazione",
        ready: "Pronto",
        delivered: "Consegnato",
        cancelled: "Annullato",
        processing: "In elaborazione",
        readyForDelivery: "Pronto per la consegna",
        delivering: "In consegna",
        awaitingPayment: "In attesa di pagamento",
        paid: "Pagato",
        refunded: "Rimborsato",
        paymentCancelled: "Annullato",
        icon: "ICONA",
        availability: "DISPONIBILITÀ",
        extraPrice: "PREZZO AGGIUNTIVO",
        searchCustomer: "Cerca un cliente",
        searchUser: "Cerca un utente",
        clearSearch: "Cancella ricerca",
        fullName: "NOME COMPLETO",
        email: "E-MAIL",
        phone: "TELEFONO",
        accountType: "TIPO DI ACCOUNT",
        verification: "VERIFICA",
        addUser: "Aggiungi utente",
        userDetails: "Dettagli utente",
        editHeadRestaurant: "Modifica il responsabile del ristorante",
        addRestaurant: "Aggiungi ristorante",
        uploadMenu: "Carica menu",
        selectPdfFile: "Seleziona un file PDF",
        maxFileSize: "Dimensione massima del file",
        acceptedFormat: "Formato accettato",
        selectedFile: "File selezionato",
        uploading: "Caricamento in corso...",
        upload: "Carica",
        addTimeSlot: "Aggiungi fascia oraria",
        addDeliveryZone: "Aggiungi zona di consegna",
        searchRestaurant: "Cerca un ristorante",
        searchTimeSlot: "Cerca una fascia oraria",
        searchZone: "Cerca una zona",
        restaurantName: "NOME RISTORANTE",
        managerName: "NOME RESPONSABILE",
        zoneAndAddress: "ZONA E INDIRIZZO",
        zoneName: "NOME ZONA",
        minimumAmount: "IMPORTO MINIMO",
        deliveryFee: "COSTI DI CONSEGNA",
        freeDeliveryThreshold: "SOGLIA CONSEGNA GRATUITA",
        postalCodes: "CODICI POSTALI",
        confirmDeleteTimeSlot: "Sei sicuro di voler eliminare questa fascia oraria?",
        confirmDeleteRestaurant: "Sei sicuro di voler eliminare questo ristorante?",
        confirmDeleteDeliveryZone: "Sei sicuro di voler eliminare questa zona di consegna?",
        addCampaign: "Aggiungi campagna",
        searchCampaign: "Cerca una campagna",
        confirmDeleteCampaign: "Sei sicuro di voler eliminare questa campagna?",
        campaignId: "ID",
        campaignTitle: "TITOLO",
        campaignMessage: "MESSAGGIO",
        campaignStatus: "STATO",
        campaignRecipients: "DESTINATARI",
        campaignCreatedAt: "CREATO IL",
        recipient: "destinatario",
        recipients: "destinatario(i)",
        selectedRecipients: "destinatario(i) selezionato(i)",
        view: "Vedi",
        send: "Invia",
        verified: "Verificato",
        unverified: "Non verificato",
        noUsers: "Nessun utente al momento",
        confirmDeleteUser: "Conferma eliminazione",
        confirmDeleteUserText: "Sei sicuro di voler eliminare questo utente?",
        confirmDeleteUserAction: "Questa azione è irreversibile.",
        noCampaigns: "Nessuna campagna al momento",
        displayResults: "Visualizzazione da {start} a {end} di {total} risultati",
        pickupDelay: "Ritardo ritiro",
        deliveryDelay: "Ritardo consegna",
        noTimeSlots: "Nessuna fascia oraria al momento",
        confirmDeleteTitle: "Conferma eliminazione",
        campaignStatuses: {
            sent: "Inviato",
            pending: "In attesa",
            draft: "Bozza",
            scheduled: "Programmato",
        },
        campaignTypes: {
            individual: "Individuale",
            group: "Gruppo",
        },
        allRestaurants: "Tutti i ristoranti",
        addToCampaign: "Aggiungi alla campagna",
        removeRecipient: "Rimuovi questo destinatario",
        usersAddedAutomatically: "{count} utenti aggiunti automaticamente",
        addCoupon: "Aggiungi coupon",
        searchCoupon: "Cerca un coupon",
        confirmDeleteCoupon: "Sei sicuro di voler eliminare questo coupon?",
        manageOpeningHours: "Gestisci gli orari di apertura del tuo ristorante",
        addOpeningHours: "Aggiungi orari",
        noOpeningHours: "Nessun orario configurato",
        startConfigureOpeningHours: "Inizia configurando gli orari di apertura del tuo ristorante.",
        configureOpeningHours: "Configura orari",
        managePaymentMethods: "Gestisci i metodi di pagamento del tuo ristorante",
        addPaymentMethod: "Aggiungi metodo di pagamento",
        paymentMethod: "Metodo di pagamento",
        noPaymentMethods: "Nessun metodo di pagamento configurato",
        startConfigurePaymentMethods: "Inizia configurando i metodi di pagamento del tuo ristorante.",
        configurePaymentMethods: "Configura metodi di pagamento",
        enabled: "Attivato",
        disabled: "Disattivato",
        selectPaymentMethod: "Seleziona metodo di pagamento",
        enablePaymentMethod: "Attiva metodo di pagamento",
        selectRestaurantFirst: "Si prega di selezionare prima un ristorante",
        day: "Giorno",
        hours: "Orari",
        break: "Pausa",
        closed: "Chiuso",
        searchTransaction: "Cerca una transazione",
        transactionId: "ID TRANSAZIONE",
        orderId: "ID ORDINE",
        confirmDeleteTransaction: "Sei sicuro di voler eliminare questa transazione?",
        addIngredientBase: "Aggiungi ingrediente base",
        searchIngredientBase: "Cerca un ingrediente base",
        addNotification: "Aggiungi notifica",
        searchNotification: "Cerca una notifica",
        confirmDeleteNotification: "Sei sicuro di voler eliminare questa notifica?",
        searchProgram: "Cerca un programma",
        programName: "NOME PROGRAMMA",
        rewardEarned: "GUADAGNO OTTENUTO",
        confirmDeleteProgram: "Sei sicuro di voler eliminare questo programma?",
        noPrograms: "Nessun programma disponibile al momento",
        referral: "REFERRAL",
        loyalty: "FEDELTÀ",
        addFranchise: "Aggiungi franchise",
        searchFranchise: "Cerca una franchise",
        confirmDeleteFranchise: "Sei sicuro di voler eliminare questa franchise?",
        title: "TITOLO",
        message: "MESSAGGIO",
        edit: "Modifica",
        confirmDeleteFranchiseText: "Sei sicuro di voler eliminare questa franchise?",
        show: "Mostra",
        platform: "Piattaforma",
        translations: "traduzioni"
    },
    reports: {
        ordersByStatus: {
            title: "Ordini per stato",
            subtitle: "Filtra per periodo e stato, poi visualizza numero e importo.",
            columns: {
                status: "Stato",
                count: "Numero",
                amount: "Importo",
            },
            empty: "Nessun dato per questo periodo.",
        },
        averageBasket: {
            title: "Carrello medio",
            subtitle: "Filtra per periodo, tipo di ordine, metodo di pagamento e stato.",
            valueLabel: "Carrello medio",
            columns: {
                count: "Numero",
                totalAmount: "Importo",
                averageBasket: "Carrello medio",
            },
            empty: "Nessun dato per questo periodo.",
        },
    },
    forms: {
        restaurantImage: "Banner immagine ristorante",
        website: "Sito Web",
        enablePosWalkthrough: "Attiva la guida interattiva del POS",
        posWalkthroughDescription: "Se attivata, il personale del ristorante vedrà una visita guidata al primo utilizzo del POS.",
        sendingType: "Tipo di invio",
        notificationType: "Tipo di notifica",
        targetChoice: "Scelta del target",
        example: "es.",
        passwordPlaceholder: "**************",
        phoneNumber: "Numero di telefono",
        country: "Paese",
        switzerland: "Svizzera",
        france: "Francia",
        germany: "Germania",
        italy: "Italia",
        unitedKingdom: "Regno Unito",
        unitedStates: "Stati Uniti",
        belgium: "Belgio",
        austria: "Austria",
        selectRestaurantPlaceholder: "Seleziona un ristorante",
        selectTypePlaceholder: "Seleziona un tipo",
        selectCategoryPlaceholder: "Seleziona una categoria",
        searchCategoryPlaceholder: "Cerca una categoria",
        chooseFile: "Scegli un file",
        imageUrlPlaceholder: "https://esempio.com/immagine.jpg",
        searchIngredientPlaceholder: "Digita per cercare un ingrediente...",
        searchSupplementPlaceholder: "Digita per cercare un supplemento...",
        searchFeaturePlaceholder: "Digita per cercare una feature...",
        sizePlaceholder: "Grande",
        sizeDescriptionPlaceholder: "Dai una descrizione per questa taglia",
        categoryDescriptionPlaceholder: "Dai una descrizione alla categoria",
        online: "Online",
        atDelivery: "Alla consegna",
        powderedSugar: "Zucchero a velo",
        addParmesan: "Aggiungi parmigiano",
        addSauces: "Aggiungi salse",
        customize: "Personalizza",
        ham: "Prosciutto",
        turkeyBreast: "Petto di tacchino",
        italianSauce: "Salsa Italiana",
        postalCode: "Codice postale",
        selectPostalCode: "Seleziona codice postale",
        city: "Città",
        selectCity: "Seleziona città",
        street: "Via",
        role: "Ruolo",
        selectRole: "Seleziona un ruolo",
        technicalSupport: "SUPPORTO TECNICO",
        oldPassword: "Vecchia password",
        newPassword: "Nuova password",
        restaurantName: "Nome Ristorante",
        managerFirstName: "Nome responsabile",
        managerLastName: "Cognome responsabile",
        vatNumber: "Numero IVA",
        address: "Indirizzo",
        streetNumber: "Numero civico",
        zoneName: "Nome zona",
        minimumAmount: "Importo minimo (CHF)",
        deliveryFee: "Costi di consegna (CHF)",
        deliveryFeePlaceholder: "es. 5.00 (lasciare vuoto per gratuito)",
        freeDeliveryThreshold: "Soglia consegna gratuita (CHF)",
        freeDeliveryThresholdPlaceholder: "es. 30.00 (lasciare vuoto per nessuna soglia)",
        description: "Descrizione",
        zoneDescription: "Descrizione zona",
        postalCodes: "Codici postali",
        postalCodePlaceholder: "Codice postale",
        locality: "Località",
        add: "Aggiungi",
        postalCodesAdded: "codice(i) postale(i) aggiunto(i)",
        noPostalCodes: "Nessun codice postale aggiunto. Puoi aggiungerli dopo la creazione della zona.",
        removePostalCode: "Rimuovi questo codice postale",
        postalCodeLocalityAlreadyAdded: "Questa combinazione di codice postale e località è già stata aggiunta",
        fillAllFields: "Si prega di compilare tutti i campi",
        createZone: "Crea zona",
        updateZone: "Aggiorna",
        pickupDelay: "Ritardo asporto (minuti)",
        pickupDelayPlaceholder: "Es: 20",
        pickupDelayHelp: "Tempo di attesa per ordini da asporto",
        deliveryDelay: "Ritardo consegna (minuti)",
        deliveryDelayPlaceholder: "Es: 45",
        deliveryDelayHelp: "Tempo di attesa per ordini in consegna",
        slotInterval: "Intervallo tra slot (minuti)",
        slotIntervalPlaceholder: "Es: 15",
        slotIntervalHelp: "Intervallo tra ogni slot disponibile",
        maxCapacity: "Capacità massima",
        maxCapacityPlaceholder: "Es: 1",
        maxCapacityHelp: "Numero massimo di ordini per slot",
        startTime: "Ora di inizio",
        startTimeHelp: "Ora di inizio degli slot",
        endTime: "Ora di fine",
        endTimeHelp: "Ora di fine degli slot",
        activateConfig: "Attiva questa configurazione",
        timeSlotExample: "Esempio: Se un cliente ordina alle 12:00 per la consegna, il prossimo preordine disponibile sarà alle 12:45 (12:00 + 45 minuti).",
        editTimeSlot: "Modifica fascia oraria",
        addTimeSlot: "Aggiungi fascia oraria",
        configureDelays: "Configura i ritardi per ordini da asporto e in consegna",
        updateTimeSlot: "Aggiorna",
        title: "Titolo",
        titlePlaceholder: "es. Novità",
        campaignDescription: "Descrizione campagna",
        recipients: "Destinatari",
        selectRestaurant: "Seleziona un ristorante",
        type: "Tipo",
        typeLabel: "Tipo",
        selectType: "Seleziona tipo",
        selectClient: "Seleziona un cliente",
        addToCampaign: "Aggiungi alla campagna",
        clientsAdded: "cliente(i) aggiunto(i)",
        selectDateTime: "Seleziona data e ora",
        couponCode: "Codice coupon",
        couponCodePlaceholder: "es. 5",
        value: "Valore",
        limit: "Limite",
        limitPlaceholder: "es. 10",
        noUserFound: "Nessun utente trovato",
        franchiseName: "Nome franchise",
        franchiseDescription: "Descrizione franchise",
        franchiseDescriptionPlaceholder: "Descrivi la franchise e le sue attività (specialità, data di creazione, ecc...)",
        image: "Immagine",
        uploadImage: "Carica un'immagine",
        imagePreview: "Anteprima immagine",
        removeImage: "Rimuovi immagine",
        changeImage: "Cambia immagine",
        selectImage: "Seleziona un'immagine",
        imageSizeWarning: "La dimensione dell'immagine non deve superare 1 MB.",
        programName: "Nome programma",
        programDescription: "Descrizione programma",
        programDescriptionPlaceholder: "Dai una descrizione al programma",
        gain: "Guadagno",
        gainPlaceholder: "es. Pizza",
        openingHoursTitle: "Orari di apertura",
        manageOpeningHours: "Gestisci gli orari di apertura del tuo ristorante",
        descriptionForDay: "Descrizione per {dayLabel}",
        addAddress: "Aggiungi un indirizzo",
        noAddressSaved: "Nessun indirizzo salvato.",
        page: "Pagina",
        noOrders: "Nessun ordine.",
        show: "Mostra",
        transactionReference: "Riferimento transazione",
        pdf: "PDF",
        civility: "Civiltà",
        lastName: "Cognome",
        firstName: "Nome",
        email: "E-mail",
        phone: "Telefono",
        dateOfBirth: "Data di nascita",
        companyName: "Nome azienda",
        companyAddress: "Indirizzo azienda",
        companyVat: "Partita IVA azienda",
        companyPhone: "Telefono azienda",
        companyEmail: "E-mail azienda",
        customerInfo: "Informazioni cliente",
        useCustomerGenericInfo: "Usa le informazioni del cliente",
        quantityUtensils: "Quantità posate",
        orderDate: "Data",
        orderTime: "Ora",
        whenOrderDesired: "Quando vorresti il tuo ordine?",
        dateAndTimeDesired: "Data e ora desiderate",
        immediately: "Immediatamente",
        whatToPayAttention: "A cosa dobbiamo fare attenzione?",
        orderInstructions: "Istruzioni ordine",
        productName: "Nome prodotto",
        quantity: "Quantità",
        price: "Prezzo",
        totalAmount: "Importo totale",
        ingredient: "Ingrediente",
        addIngredient: "Aggiungi ingrediente",
        noProductInCart: "Nessun prodotto aggiunto al carrello al momento",
        availableIn: "Disponibile in",
        size: "taglia",
        choose: "Scegli",
        cart: "Carrello",
        generalInfo: "Informazioni generali",
        chooseSize: "Scegli taglia",
        selectAdditionalIngredients: "Seleziona ingredienti aggiuntivi",
        selectIngredient: "Seleziona un ingrediente",
        averageAmount: "Importo medio",
        product: "Prodotto",
        startDate: "Inizio",
        endDate: "Fine",
        start: "Inizio",
        end: "Fine",
        category: "Categoria",
        orderType: "Tipo ordine",
        selectOrderType: "Seleziona un tipo di ordine",
        salesThisWeek: "VENDITE QUESTA SETTIMANA",
        totalOrders: "Totale ordini",
        totalSales: "Totale vendite",
        totalCustomers: "Totale clienti",
        totalProducts: "Totale prodotti",
        totalCategories: "Totale categorie",
        totalIngredients: "Totale ingredienti",
        totalTimeSlots: "Totale fasce orarie",
        totalDeliveryZones: "Totale zone di consegna",
        totalUsers: "Totale utenti",
        totalRestaurants: "Totale ristoranti",
        totalFranchises: "Totale franchise",
        totalCoupons: "Totale coupon",
        totalCampaigns: "Totale campagne",
        totalNotifications: "Totale notifiche",
        totalPrograms: "Totale programmi",
        totalIngredientBases: "Totale ingredienti base",
        totalOpeningHours: "Totale orari di apertura",
        totalTransactions: "Totale transazioni",
        totalCustomersThisMonth: "Totale clienti questo mese",
        totalOrdersThisMonth: "Totale ordini questo mese",
        totalSalesThisMonth: "Totale vendite questo mese",
        totalProductsThisMonth: "Totale prodotti questo mese",
        totalCategoriesThisMonth: "Totale categorie questo mese",
        totalIngredientsThisMonth: "Totale ingredienti questo mese",
        totalTimeSlotsThisMonth: "Totale fasce orarie questo mese",
        totalDeliveryZonesThisMonth: "Totale zone di consegna questo mese",
        totalUsersThisMonth: "Totale utenti questo mese",
        totalRestaurantsThisMonth: "Totale ristoranti questo mese",
        totalFranchisesThisMonth: "Totale franchise questo mese",
        totalCouponsThisMonth: "Totale coupon questo mese",
        totalCampaignsThisMonth: "Totale campagne questo mese",
        totalNotificationsThisMonth: "Totale notifiche questo mese",
        totalProgramsThisMonth: "Totale programmi questo mese",
        totalIngredientBasesThisMonth: "Totale ingredienti base questo mese",
        totalOpeningHoursThisMonth: "Totale orari di apertura questo mese",
        totalTransactionsThisMonth: "Totale transazioni questo mese",
        totalCustomersLastMonth: "Totale clienti il mese scorso",
        totalOrdersLastMonth: "Totale ordini il mese scorso",
        totalSalesLastMonth: "Totale vendite il mese scorso",
        totalProductsLastMonth: "Totale prodotti il mese scorso",
        totalCategoriesLastMonth: "Totale categorie il mese scorso",
        totalIngredientsLastMonth: "Totale ingredienti il mese scorso",
        totalTimeSlotsLastMonth: "Totale fasce orarie il mese scorso",
        totalDeliveryZonesLastMonth: "Totale zone di consegna il mese scorso",
        totalUsersLastMonth: "Totale utenti il mese scorso",
        totalRestaurantsLastMonth: "Totale ristoranti il mese scorso",
        totalFranchisesLastMonth: "Totale franchise il mese scorso",
        totalCouponsLastMonth: "Totale coupon il mese scorso",
        totalCampaignsLastMonth: "Totale campagne il mese scorso",
        totalNotificationsLastMonth: "Totale notifiche il mese scorso",
        totalProgramsLastMonth: "Totale programmi il mese scorso",
        totalIngredientBasesLastMonth: "Totale ingredienti base il mese scorso",
        totalOpeningHoursLastMonth: "Totale orari di apertura il mese scorso",
        totalTransactionsLastMonth: "Totale transazioni il mese scorso",
        totalCustomersLastYear: "Totale clienti l'anno scorso",
        totalOrdersLastYear: "Totale ordini l'anno scorso",
        totalSalesLastYear: "Totale vendite l'anno scorso",
        totalProductsLastYear: "Totale prodotti l'anno scorso",
        totalCategoriesLastYear: "Totale categorie l'anno scorso",
        totalIngredientsLastYear: "Totale ingredienti l'anno scorso",
        totalTimeSlotsLastYear: "Totale fasce orarie l'anno scorso",
        totalDeliveryZonesLastYear: "Totale zone di consegna l'anno scorso",
        totalUsersLastYear: "Totale utenti l'anno scorso",
        totalRestaurantsLastYear: "Totale ristoranti l'anno scorso",
        totalFranchisesLastYear: "Totale franchise l'anno scorso",
        totalCouponsLastYear: "Totale coupon l'anno scorso",
        totalCampaignsLastYear: "Totale campagne l'anno scorso",
        totalNotificationsLastYear: "Totale notifiche l'anno scorso",
        totalProgramsLastYear: "Totale programmi l'anno scorso",
        totalIngredientBasesLastYear: "Totale ingredienti base l'anno scorso",
        totalOpeningHoursLastYear: "Totale orari di apertura l'anno scorso",
        totalTransactionsLastYear: "Totale transazioni l'anno scorso",
        totalCustomersAllTime: "Totale clienti di tutti i tempi",
        totalOrdersAllTime: "Totale ordini di tutti i tempi",
        totalSalesAllTime: "Totale vendite di tutti i tempi",
        totalProductsAllTime: "Totale prodotti di tutti i tempi",
        totalCategoriesAllTime: "Totale categorie di tutti i tempi",
        totalIngredientsAllTime: "Totale ingredienti di tutti i tempi",
        totalTimeSlotsAllTime: "Totale fasce orarie di tutti i tempi",
        totalDeliveryZonesAllTime: "Totale zone di consegna di tutti i tempi",
        totalUsersAllTime: "Totale utenti di tutti i tempi",
        totalRestaurantsAllTime: "Totale ristoranti di tutti i tempi",
        totalFranchisesAllTime: "Totale franchise di tutti i tempi",
        totalCouponsAllTime: "Totale coupon di tutti i tempi",
        totalCampaignsAllTime: "Totale campagne di tutti i tempi",
        totalNotificationsAllTime: "Totale notifiche di tutti i tempi",
        totalProgramsAllTime: "Totale programmi di tutti i tempi",
        totalIngredientBasesAllTime: "Totale ingredienti base di tutti i tempi",
        totalOpeningHoursAllTime: "Totale orari di apertura di tutti i tempi",
        totalTransactionsAllTime: "Totale transazioni di tutti i tempi",
        totalCustomersToday: "Totale clienti oggi",
        totalOrdersToday: "Totale ordini oggi",
        totalSalesToday: "Totale vendite oggi",
        totalProductsToday: "Totale prodotti oggi",
        totalCategoriesToday: "Totale categorie oggi",
        totalIngredientsToday: "Totale ingredienti oggi",
        totalTimeSlotsToday: "Totale fasce orarie oggi",
        totalDeliveryZonesToday: "Totale zone di consegna oggi",
        totalUsersToday: "Totale utenti oggi",
        totalRestaurantsToday: "Totale ristoranti oggi",
        totalFranchisesToday: "Totale franchise oggi",
        totalCouponsToday: "Totale coupon oggi",
        totalCampaignsToday: "Totale campagne oggi",
        totalNotificationsToday: "Totale notifiche oggi",
        totalProgramsToday: "Totale programmi oggi",
        totalIngredientBasesToday: "Totale ingredienti base oggi",
        totalOpeningHoursToday: "Totale orari di apertura oggi",
        totalTransactionsToday: "Totale transazioni oggi",
        totalCustomersYesterday: "Totale clienti ieri",
        totalOrdersYesterday: "Totale ordini ieri",
        totalSalesYesterday: "Totale vendite ieri",
        totalProductsYesterday: "Totale prodotti ieri",
        totalCategoriesYesterday: "Totale categorie ieri",
        totalIngredientsYesterday: "Totale ingredienti ieri",
        totalTimeSlotsYesterday: "Totale fasce orarie ieri",
        totalDeliveryZonesYesterday: "Totale zone di consegna ieri",
        totalUsersYesterday: "Totale utenti ieri",
        totalRestaurantsYesterday: "Totale ristoranti ieri",
        totalFranchisesYesterday: "Totale franchise ieri",
        totalCouponsYesterday: "Totale coupon ieri",
        totalCampaignsYesterday: "Totale campagne ieri",
        totalNotificationsYesterday: "Totale notifiche ieri",
        totalProgramsYesterday: "Totale programmi ieri",
        totalIngredientBasesYesterday: "Totale ingredienti base ieri",
        totalOpeningHoursYesterday: "Totale orari di apertura ieri",
        totalTransactionsYesterday: "Totale transazioni ieri",
        totalCustomersLast7Days: "Totale clienti ultimi 7 giorni",
        totalOrdersLast7Days: "Totale ordini ultimi 7 giorni",
        totalSalesLast7Days: "Totale vendite ultimi 7 giorni",
        totalProductsLast7Days: "Totale prodotti ultimi 7 giorni",
        totalCategoriesLast7Days: "Totale categorie ultimi 7 giorni",
        totalIngredientsLast7Days: "Totale ingredienti ultimi 7 giorni",
        totalTimeSlotsLast7Days: "Totale fasce orarie ultimi 7 giorni",
        totalDeliveryZonesLast7Days: "Totale zone di consegna ultimi 7 giorni",
        totalUsersLast7Days: "Totale utenti ultimi 7 giorni",
        totalRestaurantsLast7Days: "Totale ristoranti ultimi 7 giorni",
        totalFranchisesLast7Days: "Totale franchise ultimi 7 giorni",
        totalCouponsLast7Days: "Totale coupon ultimi 7 giorni",
        totalCampaignsLast7Days: "Totale campagne ultimi 7 giorni",
        totalNotificationsLast7Days: "Totale notifiche ultimi 7 giorni",
        totalProgramsLast7Days: "Totale programmi ultimi 7 giorni",
        totalIngredientBasesLast7Days: "Totale ingredienti base ultimi 7 giorni",
        totalOpeningHoursLast7Days: "Totale orari di apertura ultimi 7 giorni",
        totalTransactionsLast7Days: "Totale transazioni ultimi 7 giorni",
        totalCustomersLast30Days: "Totale clienti ultimi 30 giorni",
        totalOrdersLast30Days: "Totale ordini ultimi 30 giorni",
        totalSalesLast30Days: "Totale vendite ultimi 30 giorni",
        totalProductsLast30Days: "Totale prodotti ultimi 30 giorni",
        totalCategoriesLast30Days: "Totale categorie ultimi 30 giorni",
        totalIngredientsLast30Days: "Totale ingredienti ultimi 30 giorni",
        totalTimeSlotsLast30Days: "Totale fasce orarie ultimi 30 giorni",
        totalDeliveryZonesLast30Days: "Totale zone di consegna ultimi 30 giorni",
        totalUsersLast30Days: "Totale utenti ultimi 30 giorni",
        totalRestaurantsLast30Days: "Totale ristoranti ultimi 30 giorni",
        totalFranchisesLast30Days: "Totale franchise ultimi 30 giorni",
        totalCouponsLast30Days: "Totale coupon ultimi 30 giorni",
        totalCampaignsLast30Days: "Totale campagne ultimi 30 giorni",
        totalNotificationsLast30Days: "Totale notifiche ultimi 30 giorni",
        totalProgramsLast30Days: "Totale programmi ultimi 30 giorni",
        totalIngredientBasesLast30Days: "Totale ingredienti base ultimi 30 giorni",
        totalOpeningHoursLast30Days: "Totale orari di apertura ultimi 30 giorni",
        totalTransactionsLast30Days: "Totale transazioni ultimi 30 giorni",
        totalCustomersLast90Days: "Totale clienti ultimi 90 giorni",
        totalOrdersLast90Days: "Totale ordini ultimi 90 giorni",
        totalSalesLast90Days: "Totale vendite ultimi 90 giorni",
        totalProductsLast90Days: "Totale prodotti ultimi 90 giorni",
        totalCategoriesLast90Days: "Totale categorie ultimi 90 giorni",
        totalIngredientsLast90Days: "Totale ingredienti ultimi 90 giorni",
        totalTimeSlotsLast90Days: "Totale fasce orarie ultimi 90 giorni",
        totalDeliveryZonesLast90Days: "Totale zone di consegna ultimi 90 giorni",
        totalUsersLast90Days: "Totale utenti ultimi 90 giorni",
        totalRestaurantsLast90Days: "Totale ristoranti ultimi 90 giorni",
        totalFranchisesLast90Days: "Totale franchise ultimi 90 giorni",
        totalCouponsLast90Days: "Totale coupon ultimi 90 giorni",
        totalCampaignsLast90Days: "Totale campagne ultimi 90 giorni",
        totalNotificationsLast90Days: "Totale notifiche ultimi 90 giorni",
        totalProgramsLast90Days: "Totale programmi ultimi 90 giorni",
        totalIngredientBasesLast90Days: "Totale ingredienti base ultimi 90 giorni",
        totalOpeningHoursLast90Days: "Totale orari di apertura ultimi 90 giorni",
        totalTransactionsLast90Days: "Totale transazioni ultimi 90 giorni",
        totalCustomersLast365Days: "Totale clienti ultimi 365 giorni",
        totalOrdersLast365Days: "Totale ordini ultimi 365 giorni",
        totalSalesLast365Days: "Totale vendite ultimi 365 giorni",
        totalProductsLast365Days: "Totale prodotti ultimi 365 giorni",
        totalCategoriesLast365Days: "Totale categorie ultimi 365 giorni",
        totalIngredientsLast365Days: "Totale ingredienti ultimi 365 giorni",
        totalTimeSlotsLast365Days: "Totale fasce orarie ultimi 365 giorni",
        totalDeliveryZonesLast365Days: "Totale zone di consegna ultimi 365 giorni",
        totalUsersLast365Days: "Totale utenti ultimi 365 giorni",
        totalRestaurantsLast365Days: "Totale ristoranti ultimi 365 giorni",
        totalFranchisesLast365Days: "Totale franchise ultimi 365 giorni",
        totalCouponsLast365Days: "Totale coupon ultimi 365 giorni",
        totalCampaignsLast365Days: "Totale campagne ultimi 365 giorni",
        totalNotificationsLast365Days: "Totale notifiche ultimi 365 giorni",
        totalProgramsLast365Days: "Totale programmi ultimi 365 giorni",
        totalIngredientBasesLast365Days: "Totale ingredienti base ultimi 365 giorni",
        totalOpeningHoursLast365Days: "Totale orari di apertura ultimi 365 giorni",
        totalTransactionsLast365Days: "Totale transazioni ultimi 365 giorni",
        totalCustomersLastWeek: "Totale clienti la scorsa settimana",
        totalOrdersLastWeek: "Totale ordini la scorsa settimana",
        totalSalesLastWeek: "Totale vendite la scorsa settimana",
        totalProductsLastWeek: "Totale prodotti la scorsa settimana",
        totalCategoriesLastWeek: "Totale categorie la scorsa settimana",
        totalIngredientsLastWeek: "Totale ingredienti la scorsa settimana",
        totalTimeSlotsLastWeek: "Totale fasce orarie la scorsa settimana",
        totalDeliveryZonesLastWeek: "Totale zone di consegna la scorsa settimana",
        totalUsersLastWeek: "Totale utenti la scorsa settimana",
        totalRestaurantsLastWeek: "Totale ristoranti la scorsa settimana",
        totalFranchisesLastWeek: "Totale franchise la scorsa settimana",
        totalCouponsLastWeek: "Totale coupon la scorsa settimana",
        totalCampaignsLastWeek: "Totale campagne la scorsa settimana",
        totalNotificationsLastWeek: "Totale notifiche la scorsa settimana",
        totalProgramsLastWeek: "Totale programmi la scorsa settimana",
        totalIngredientBasesLastWeek: "Totale ingredienti base la scorsa settimana",
        totalOpeningHoursLastWeek: "Totale orari di apertura la scorsa settimana",
        totalTransactionsLastWeek: "Totale transazioni la scorsa settimana",
        filterByRestaurant: "Filtra per ristorante",
        amountOrdersByCategory: "IMPORTO ORDINI PER (CATEGORIA)",
        amountOrdersByProduct: "IMPORTO ORDINI PER (PRODOTTO)",
        allTypes: "Tutti i tipi",
        allMethods: "Tutti i metodi",
        orders: "ordine/i",
        Orders: "Ordine/i",
        averageQuantityPerOrder: "QUANTITÀ MEDIA DI UN PRODOTTO PER ORDINE",
        errorLoadingCategories: "Errore nel caricamento delle categorie",
        errorLoadingProducts: "Errore nel caricamento dei prodotti",
        errorLoadingData: "Errore nel caricamento dei dati",
        errorLoadingRestaurant: "Errore nel caricamento dei ristoranti",
        errorLoadingAverage: "Errore nel recupero della media",
        errorLoadingAverageRate: "Errore nel caricamento del tasso medio",
        pleaseSelectRestaurant: "Seleziona un ristorante specifico per visualizzare i dati.",
        pleaseSelectRestaurantRefresh: "Seleziona un ristorante per aggiornare i dati.",
        noProductDataForPeriod: "Nessun dato prodotto per questo periodo",
        noCategoryDataForPeriod: "Nessun dato categoria per questo periodo",
        allowOrderModification: "Autorizza la modifica degli ordini",
        allowOrderDeletion: "Autorizza l'eliminazione degli ordini",
        allowOrderAcceptation: "Autorizza l'accettazione degli ordini",
        showGoogleMapsQr: "Mostra QR Code Google Maps sui biglietti",
        showGoogleMapsQrHelp: "Indica se il QR code di Google Maps deve essere visualizzato sui biglietti",
    },
    ingredientBase: {
        addIngredientBase: "Aggiungi ingrediente base",
        editIngredientBase: "Modifica ingrediente base",
        ingredientBaseName: "Nome ingrediente base",
        ingredientBaseNameHelp: "Inserisci il nome dell'ingrediente base per le pizze",
        ingredientBasePosition: "Posizione",
        ingredientBasePositionPlaceholder: "es. 1, 2, 3...",
        ingredientBasePositionHelp: "Posizione dell'ingrediente base nella lista (opzionale)",
    },
    pos: {
        searchMenuPlaceholder: "Cerca nel menu...",
        noCategoriesFound: "Nessuna categoria trovata",
        errorLoadingCategories: "Errore durante il caricamento delle categorie",
        noActiveProductsFound: "Nessun prodotto attivo trovato per questa categoria",
        errorLoadingProducts: "Errore durante il caricamento dei prodotti",
        ingredientsLoadedSuccess: "Ingredienti caricati con successo",
        errorLoadingIngredients: "Errore durante il caricamento degli ingredienti",
        additionalOptions: "Opzioni aggiuntive",
        selectOneOption: "Si prega di selezionare un'opzione",
        customizeProduct: "Personalizza il tuo prodotto",
        includedIngredientsInfo: "Gli ingredienti contrassegnati \"Incluso\" vengono con la pizza",
        addModeDescription: "Modalità Aggiungi: aggiungi ingredienti aggiuntivi",
        removeModeDescription: "Modalità Rimuovi: rimuovi anche gli ingredienti inclusi",
        included: "Incluso",
        free: "Gratuito",
        unknownIngredient: "Ingrediente sconosciuto",
        addToCart: "Aggiungi al carrello",
        add: "Aggiungi",
        customize: "Personalizza",
        customizeIngredients: "Personalizza ingredienti",
        remove: "Rimuovi",
        addSpecialInstructions: "Aggiungi istruzioni speciali per il tuo ordine...",
        customizeSalad: "Personalizza insalata",
        customizePasta: "Personalizza pasta",
        customizeOptions: "Personalizza opzioni",
        customizeYour: "Personalizza i tuoi",
        chooseOption: "Scegli un'opzione",
        selectedOption: "Opzione selezionata",
        addParmesanDescription: "Aggiungi parmigiano grattugiato per ancora più sapore (1.00 CHF):",
        createCustomPizza: "Crea la tua pizza personalizzata",
        searchIngredient: "Cerca un ingrediente...",
        pizzaSummary: "Riepilogo della tua pizza",
        sizeLabel: "Taglia",
        noIngredientsSelected: "Nessun ingrediente selezionato",
        chooseSize: "Scegli taglia",
        glutenFree: "Senza glutine",
        deliveryPrice: "Prezzo di consegna",
        noProductsFound: "Nessun prodotto trovato",
        tryChangeSearchOrCategory: "Prova a cambiare la tua ricerca o la categoria selezionata.",
        addSaucesForSalad: "Aggiungi salse per esaltare la tua insalata.",
        chooseYourSauces: "Scegli le tue salse",
        cart: "Carrello",
        generalInfo: "Informazioni generali",
        noProductInCart: "Nessun prodotto aggiunto al carrello al momento",
        availableIn: "Disponibile in",
        size: "taglia",
        choose: "Scegli",
        orderInstructions: "Istruzioni ordine",
        selectOrderType: "Seleziona tipo ordine",
        whenOrder: "Quando vorresti il tuo ordine?",
        whatToPayAttention: "A cosa dobbiamo fare attenzione?",
        orderNotes: "Note ordine",
        requestUtensils: "Richiesta posate",
        utensilsQuantity: "Quantità posate",
        useCustomerInfo: "Usa informazioni cliente",
        cookingType: {
            normal: "Normale",
            rare: "Al sangue",
            medium: "Media cottura",
            wellDone: "Ben cotto",
        },
        schedule: {
            morningOpening: "Apertura mattutina",
            lunchBreak: "Pausa pranzo",
            afternoonOpening: "Apertura pomeridiana",
        },
        customerInfo: "Informazioni Cliente",
        registeredCustomerSelected: "Cliente registrato selezionato",
        deselect: "Deseleziona",
        firstName: "Nome",
        firstNamePlaceholder: "Nome del cliente",
        lastName: "Cognome",
        lastNamePlaceholder: "Cognome del cliente",
        phone: "Telefono",
        phonePlaceholder: "Numero di telefono",
        email: "E-mail",
        emailPlaceholder: "E-mail del cliente",
        invalidEmail: "Inserisci un indirizzo e-mail valido",
        orderType: "Tipo di ordine",
        orderTypeDineIn: "Sul posto",
        orderTypeClickCollect: "Da asporto",
        orderTypeDelivery: "Consegna",
        clientType: "Tipo cliente",
        clientTypeCustomer: "Cliente",
        clientTypeOrganisation: "Organizzazione",
        company: "Società",
        companyPlaceholder: "Nome della società",
        department: "Dipartimento",
        departmentPlaceholder: "Dipartimento",
        pickupTime: "Orario di ritiro",
        pickupTimeHour: "Orario di ritiro",
        asSoonAsPossible: "Il prima possibile",
        restaurantClosed: "(Ristorante chiuso)",
        readyInMinutes: "Pronto tra 15-20 minuti",
        scheduledDateTime: "Data e ora desiderate",
        scheduleForLater: "Programma per dopo",
        pickupDate: "Data di ritiro",
        selectDate: "Seleziona una data",
        selectTime: "Seleziona un orario",
        noTimeAvailableToday: "Nessun orario disponibile oggi. Si prega di selezionare domani.",
        deliveryAddress: "Indirizzo di consegna",
        savedAddresses: "Indirizzi salvati",
        newAddress: "Nuovo indirizzo",
        postalCode: "Codice postale (CAP)",
        postalCodePlaceholder: "Codice postale",
        locality: "Località",
        localityPlaceholder: "Località",
        street: "Via",
        streetPlaceholder: "Nome della via",
        streetNumber: "Numero civico",
        streetNumberPlaceholder: "Numero civico",
        order: "Ordine",
        items: "articolo(i)",
        emptyCart: "Carrello vuoto",
        addItemsToStart: "Aggiungi articoli per iniziare",
        summary: "Riepilogo",
        promoCode: "Codice promozionale",
        enterPromoCode: "Inserisci il tuo codice promozionale",
        apply: "Applica",
        couponRemoved: "Coupon rimosso",
        minimumOrderAmount: "Importo minimo ordine:",
        supplementApplied: "(supplemento di {amount} CHF applicato)",
        disableMinOrder: "Disattiva importo minimo",
        enableMinOrder: "Riattiva importo minimo",
        discountType: "Tipo di sconto",
        percentage: "Percentuale (%)",
        fixedAmount: "Importo fisso (CHF)",
        discount: "Sconto",
        discountPercentage: "Sconto (%)",
        discountFixed: "Sconto (CHF)",
        miscellaneous: "Varie (CHF)",
        miscellaneousLabel: "Varie",
        slice: "Affettare:",
        yes: "Sì",
        no: "No",
        note: "Nota",
        notePlaceholder: "Inserisci la tua nota",
        subtotal: "Subtotale",
        discountLabel: "Sconto",
        coupon: "Coupon",
        customized: "Personalizzato:",
        removed: "Rimosso:",
        options: "Opzioni:",
        supplements: "Supplementi:",
        minOrderSupplement: "Supplemento minimo ordine",
        vat: "IVA ({rate}%)",
        total: "Totale",
        validateOrder: "Conferma ordine",
        processing: "Elaborazione...",
        orderCreatedSuccess: "Ordine creato con successo!",
        fillAllFields: "Si prega di compilare tutti i campi!",
        restaurantInfoMissing: "Informazioni ristorante mancanti",
        invalidPromoCode: "Codice promozionale non valido",
        orderCreationError: "Errore durante la creazione dell'ordine",
        today: "Oggi",
        tomorrow: "Domani",
    },
    dashboard: {
        greeting: "Ciao",
        whatHappeningToday: "Ecco cosa sta succedendo nei tuoi ristoranti oggi",
        whatHappeningTodaySingle: "Ecco cosa sta succedendo nel tuo ristorante oggi",
        salesThisWeek: "VENDITE QUESTA SETTIMANA",
        salesThisWeekByRestaurant: "Vendite della settimana corrente per ristorante",
        salesThisWeekLabel: "Vendite questa settimana",
        vsPreviousWeek: "vs settimana precedente:",
        previousWeek: "Settimana precedente",
        thisWeek: "Questa settimana",
        thisMonth: "Questo mese",
        thisYear: "Quest'anno",
        select: "Seleziona",
        noDataAvailable: "Nessun dato disponibile per il grafico",
        salesReportThisWeek: "REPORT VENDITE QUESTA SETTIMANA",
        salesReportThisMonth: "REPORT VENDITE QUESTO MESE",
        salesReportThisYear: "REPORT VENDITE QUESTO ANNO",
        salesReportAllPeriods: "REPORT VENDITE TUTTI I PERIODI",
        salesReportPreviousWeek: "REPORT VENDITE SETTIMANA PRECEDENTE",
    },
    pages: {
        editCustomer: "Modifica cliente",
        addFranchise: "Aggiungi franchise",
        updateFranchise: "Aggiorna franchise",
        addProduct: "Aggiungi prodotto",
        updateProduct: "Aggiorna prodotto",
        orderDetails: "Dettagli ordine",
        openingHours: "Orari di apertura",
        paymentMethods: "Metodi di pagamento",
        generalInfo: "Informazioni generali",
        addDeliveryZone: "Aggiungi zona di consegna",
        updateDeliveryZone: "Aggiorna zona di consegna",
        customerList: "Lista clienti",
        addCustomer: "Aggiungi cliente",
        customerDetails: "Dettagli cliente",
        ingredientList: "Lista ingredienti",
        ingredientTypeList: "Lista tipi di ingredienti",
        addIngredient: "Aggiungi ingrediente",
        updateIngredient: "Aggiorna ingrediente",
        timeSlotList: "Lista fasce orarie",
        addUser: "Aggiungi utente",
        updateUserInfo: "Aggiorna le mie informazioni",
        userList: "Lista utenti",
        addCategory: "Aggiungi categoria",
        updateCategory: "Aggiorna categoria",
        categoryList: "Lista categorie",
        productList: "Lista prodotti",
        createCoupon: "Crea coupon",
        couponDetails: "Dettagli coupon",
        couponList: "Lista coupon",
        franchises: "Franchise",
        addProgram: "Aggiungi programma",
        updateProgram: "Aggiorna programma",
        referralLoyalty: "Referral & Fedeltà",
        deliveryZoneList: "Zone di consegna",
        postalCodes: "Codici postali",
        notificationList: "Lista notifiche",
        sendNotification: "Invia notifica",
        notificationDetails: "Dettagli notifica",
        campaignList: "Lista campagne",
        addCampaign: "Aggiungi campagna",
        campaignDetails: "Dettagli campagna",
        restaurantList: "Lista ristoranti",
        addRestaurant: "Aggiungi ristorante",
        updateRestaurant: "Aggiorna",
        ingredientBaseList: "Lista ingredienti base",
        transactionDetails: "Dettagli transazione",
        orders: "Ordini",
        transactions: "Transazioni",
        configureOpeningHours: "Configura orari di apertura",
        configureOpeningHoursSubtitle: "Definisci i giorni e gli orari di apertura del tuo ristorante",
        saveOpeningHours: "Salva orari",
        optionalBreak: "Pausa (opzionale)",
        openingDays: "Giorni di apertura",
        open: "Aperto",
        partialOpen: "Parzialmente aperto",
        detailedHours: "Orari dettagliati",
        opening: "Apertura",
        start: "Inizio",
        end: "Fine",
        break: "Pausa",
        breakStart: "Inizio pausa",
        breakEnd: "Fine pausa",
        addHours: "Aggiungi orari",
        addBreak: "Aggiungi una pausa",
        removeHours: "Rimuovi orari",
        removeBreak: "Rimuovi pausa",
        dayStatus: "Stato del giorno",
        descriptionForDay: "Descrizione per {dayLabel}",
        daysOfWeek: {
            monday: "Lunedì",
            tuesday: "Martedì",
            wednesday: "Mercoledì",
            thursday: "Giovedì",
            friday: "Venerdì",
            saturday: "Sabato",
            sunday: "Domenica",
        },
        resetPassword: "Reimposta Password",
        emailConfirmation: "Conferma E-mail",
        forgotPassword: "Password Dimenticata",
        register: "Registrati",
        addTimeSlot: "Aggiungi fascia oraria",
        updateTimeSlot: "Aggiorna fascia oraria",
        thisWeek: "Questa settimana",
        thisMonth: "Questo mese",
        thisYear: "Quest'anno",
        addTimeRange: "Aggiungi fascia oraria",
        timeRange: "Fascia oraria",
        deliverySlotConfig: "Configurazione slot di consegna",
        active: "Attivo",
        inactive: "Inattivo",
        selected: "Selezionato",
        selectDayToConfigureHours: "Clicca su un giorno aperto per configurare i suoi orari dettagliati",
        configureTimeRangesForDay: "Configura le fasce orarie per questo giorno",
        noTimeRanges: "Nessuna fascia oraria configurata",
    },
    customer: {
        averageBasket: "Carrello medio",
        orderChannelsBreakdown: "Ripartizione dei canali di commande",
        customerSpecification: "SPECIFICA DEL CLIENTE",
        registeredAddressesList: "Elenco degli indirizzi registrati",
        remark: "Osservazione",
        noRegisteredAddresses: "Nessun indirizzo registrato.",
        orderAnalysis: "Analisi durante gli ordini",
        specificAttentionPoints: "Punti di attenzione specifici",
        enterAttentionPoints: "Inserisci i punti di attenzione...",
        orderTypesHistory: "Storico dei tipi di ordine",
        cutleryRequestDuringOrders: "Richiesta di posate durante gli ordini",
        clientPaymentHabits: "Abitudini di pagamento del cliente",
        totalOrdersNumber: "Numero totale di ordini",
        orderHistoryTable: "Tabella storico ordini",
        orderHistory: "Storico ordini",
        primarilyOrdersType: "Il cliente effettua principalmente ordini di tipo \"{type}\" ({count}/{total}).",
        varietyOrderTypes: "Il cliente presenta una varietà di tipi di ordine. Tipo dominante: \"{type}\" ({count}/{total}).",
        alwaysRequestsCutlery: "Il cliente richiede sistematicamente le posate con i suoi ordini.",
        neverRequestsCutlery: "Il cliente non richiede mai le posate.",
        majorityRequestsCutlery: "Il cliente richiede le posate nella maggior parte dei casi.",
        rarelyRequestsCutlery: "Il cliente richiede raramente le posate.",
        requestsCutleryAmount: "Il cliente richiede {amount} pezzo(i) di posate per i suoi ordini.",
        exclusivelyUsesPaymentMethod: "Il cliente utilizza esclusivamente il metodo di pagamento \"{method}\".",
    },
    posClient: {
        title: "Cliente POS",
        description: "Questo cliente verrà utilizzato per impostazione predefinita per gli ordini effettuati sul POS se non viene selezionato alcun cliente.",
        add: "Aggiungi cliente POS",
        edit: "Modifica cliente POS",
        delete: "Elimina cliente POS",
        confirmDelete: "Sei sicuro di voler eliminare questo cliente POS?",
        saved: "Cliente POS salvato con successo",
        deleted: "Cliente POS eliminato con successo",
        notFound: "Cliente POS non trovato",
        firstName: "Nome",
        lastName: "Cognome",
        email: "E-mail (opzionale)",
        phone: "Telefono",
        civility: "Civiltà",
    },
    loyalty: {
        totalReferralsInRange: "Totale referral in questo periodo",
        reportTitle: "Giornale dei punti fedeltà",
        reportCustomer: "CLIENTE",
        reportAction: "AZIONE",
        reportPoints: "PUNTI",
        reportBalance: "SALDO",
        reportDate: "Data",
        reportLastActivity: "Ultima attività",
        earn: "Guadagnato",
        spend: "Speso",
        reverse: "Stornato",
        expired: "Scaduto",
        adjustPoints: "Regola punti",
        reverseTransaction: "Annulla transazione",
        reverseSuccess: "Transazione annullata con successo",
        adjustSuccess: "Punti regolati con successo",
        reason: "Motivo",
        amount: "Importo",
        confirmReverse: "Sei sicuro di voler annullare questa transazione?",
        confirmAdjust: "Sei sicuro di voler regolare i punti di questo cliente?",
        referralReport: "Rapporto Referral",
        topReferrers: "Migliori Referenti",
        referrer: "Referente",
        referee: "Invitato",
        referralDate: "Data di invito",
        pointsEarned: "Punti guadagnati",
        rewardStatus: "Stato premio",
        rewarded: "Premiato",
        pending: "In attesa",
        searchReferral: "Cerca referente o invitato...",
        referralDetails: "Dettagli referral",
        noReferrals: "Nessun referral trovato per questo periodo.",
        totalReferrals: "Totale Referral",
        totalPoints: "Totale Punti"
    },
};
